import { TabsProps } from '@/common/components/Tabs'
import MaintenanceWorkflowForwardingsTab from '@/features/maintenanceWorkflow/pages/Show/components/tabs/ForwardingsTabs'
import MaintenanceDescription from '@/features/maintenanceWorkflow/pages/Show/components/tabs/MaintenanceDescription'
import { maintenanceForwardingsDirectiveEntryKlasses } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.type'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { createElement } from 'react'

export const getWorkflowTabsList = (
  workflow: MaintenanceWorkflowData | undefined,
  forwardingsDirectiveEntryKlasses: MaintenanceForwardingsDirectiveEntryKlass[] | undefined,
) => {
  let forwardingsDirectiveEntryKlassesTabs: TabsProps['tabsList'] = []

  if (forwardingsDirectiveEntryKlasses) {
    forwardingsDirectiveEntryKlassesTabs = forwardingsDirectiveEntryKlasses
      .map((directiveEntryKlass) => {
        const tab = maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass]

        if (!tab) {
          return false
        }

        return {
          value: directiveEntryKlass,
          label: tab.label,
          body: createElement(MaintenanceWorkflowForwardingsTab, {
            workflow,
            directiveEntryKlass,
          }),
          operationKlassToCheckPermission: 'Client::Maintenance::Workflows::FilterForwardings',
        }
      })
      .filter((tab) => tab) as TabsProps['tabsList']
  }

  return [
    {
      label: 'Descrição da manutenção',
      value: '',
      body: createElement(MaintenanceDescription, { workflow }),
    },
    ...forwardingsDirectiveEntryKlassesTabs,
  ] as TabsProps['tabsList']
}
